import React, { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import { setCartFromTab } from '../../actions/cart'
import { setOrderInProgress } from '../../actions/order'
import { printOrder } from '../../actions/printer'
import { getSelectedOrder } from '../../selectors/order'
import { getDiscountsAvailable } from '../../selectors/promotion'
import { isTabbed } from '../../utils/orderStates'
import RoundButton from '../../components/RoundButton'
import { getBackbarMode } from '../../selectors/config'
import { getIsKiosk } from '../../selectors/menus'
import { getUsbPrintingEnabled } from '../../selectors/printer'

const BackBarButtons = ({ className }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const order = useSelector((state) => getSelectedOrder(state))
  const isKiosk = useSelector((state) => getIsKiosk(state))
  const isTab = isTabbed(order)
  const isBackBar = useSelector((state) => getBackbarMode(state))
  const discountsAvailable = useSelector((state) => getDiscountsAvailable(state))
  const usbPrintingEnabled = useSelector((state) => getUsbPrintingEnabled(state))

  const shouldRender = useMemo(() => {
    if (!isBackBar) return false
    if (isKiosk) return false
    if (!isTab) return false

    return true
  }, [isKiosk, isTab, isBackBar])

  const printCheckHandler = useCallback(() => {
    dispatch(
      printOrder({
        orderUuid: order?.uuid,
        isNewOrder: false,
        redirectionRoute: '/orders',
      }),
    )
  }, [])
  const finalizeHandler = useCallback(() => {}, [])
  const printSlipHandler = useCallback(() => {
    // check if order has payment attached already
    dispatch(setOrderInProgress(order))
    dispatch(setCartFromTab(order))

    if (discountsAvailable && order?.wasCreatedInStadium) {
      return history.push('/discounts')
    }
    history.push('/tender-selection')
  }, [dispatch, discountsAvailable, history, order])

  if (!shouldRender) {
    return null
  }

  return (
    <>
      <RoundButton
        className={className}
        text="Print Check"
        onClick={printCheckHandler}
        disabled={!usbPrintingEnabled && !order?.wasCreatedInStadium}
      />
      <RoundButton text="Print Slip" className={className} onClick={printSlipHandler} />
      <RoundButton className={className} text="Add Tip & Finalize" onClick={finalizeHandler} />
    </>
  )
}

export default BackBarButtons
